import { Component, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '@app/providers/auth/auth.service';

@Component({
  selector: 'callback-service',
  template: '',
})
export class CallbackComponent {
  constructor(route: ActivatedRoute, router: Router, injector: Injector) {
    const serviceId = route.snapshot.params.service;

    if (serviceId === 'cognito') {
      injector
        .get(AuthService)
        .isAuthenticated()
        .finally(() => router.navigate(['login']));
    }
  }
}
